export type PortalMode = "live" | "maintenance" | "error";

const PORTAL_MODES: PortalMode[] = ["live", "maintenance", "error"];
const DEFAULT_PORTAL_MODE: PortalMode = "live";

/**
 * Reads `customer_portal_mode` out of the maintenance-settings response. The
 * portal is live by default: only an explicit `maintenance` or `error` from a
 * successful response takes it down, so a failed, empty, or unrecognised
 * payload can never lock customers out.
 */
export const resolvePortalMode = (response: any): PortalMode => {
  const mode = response?.body?.success
    ? response?.body?.data?.customer_portal_mode
    : null;
  const normalizedMode =
    typeof mode === "string" ? mode.trim().toLowerCase() : "";

  return PORTAL_MODES.includes(normalizedMode as PortalMode)
    ? (normalizedMode as PortalMode)
    : DEFAULT_PORTAL_MODE;
};
